
import { isNull } from 'lodash'

export default {
  name: 'ProductCardName',
  props: {
    name: {
      type: String,
      default: '',
      required: true,
    },
    productDetailLinkData: {
      type: Object,
      default() {
        return {}
      },
    },
    productIsHavingLink: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  computed: {
    nameFormatted() {
      const name = this.name ?? null
      if (isNull(name)) return ''
      return name.replace(/&nbsp;/g, ' ')
    },
  },
}
